export enum TimezoneRegion {
  CentralEuropean = 0,
  Finland = 1,
}